module.exports = __webpack_public_path__ + "media/react/payments/pages/add_ons/assets/mba_admissions/headshot_jen-2ec5e56b571f57a29b9836c56343f754.png";